export enum SubjectSubstitution {
    Start = "Start",
    End = "End"
}

export interface AddToSubjectRuleContent {
    where: SubjectSubstitution;
    string: string;
}
